import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconHeart(props: Readonly<IconWrapperProps>) {
  return (
    <IconWrapper {...props}>
      <svg fill="none" viewBox="0 0 22 18" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.1006 1.43457C14.562 0.413079 16.5085 0.198233 18.082 0.941406C19.6596 1.68666 20.8209 3.42234 20.873 5.25879C20.9234 7.0412 20.0204 8.73834 18.9277 10.2881C17.3285 12.5567 14.1268 15.5561 10.6875 17.4287C7.24825 15.5561 4.04642 12.5566 2.44727 10.2881C1.35461 8.73836 0.451595 7.04128 0.501953 5.25879C0.55375 3.42247 1.71572 1.68771 3.29297 0.942383C4.8669 0.19914 6.81335 0.413037 8.27441 1.43457C9.10322 2.0142 9.77665 2.84092 10.2373 3.79785L10.6875 4.73438L11.1387 3.79785C11.599 2.84091 12.2718 2.01416 13.1006 1.43457Z"
          stroke="currentColor"
          strokeLinecap="square"
          strokeWidth="1.5"
        />
      </svg>
    </IconWrapper>
  );
}
